module.exports = __webpack_public_path__ + "img/ic_supervision_publicity2.7857b742.png";